import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {AmplitudeAuthPlacement} from "../../../tracking/types/AmplitudeAuthPlacement";
import {LoginForm} from "./LoginForm";
import {SocialAuth} from "./SocialAuth";

interface IProps {
    socialAuthSuccess: () => void;
    emailAuthSuccess: () => void;
    userSource: UserSource;
    gtmSourceSection?: string;
    amplitudePlacement?: AmplitudeAuthPlacement;
}

export const SemanticSearchLoginForm = (props: IProps) => {
    const {userSource, gtmSourceSection, socialAuthSuccess, emailAuthSuccess, amplitudePlacement} = props;

    return (
        <>
            <SocialAuth
                onAuthSuccess={socialAuthSuccess}
                userSource={userSource}
                gtmSourceSection={gtmSourceSection}
                amplitudePlacement={amplitudePlacement}
                authContext="login"
            />

            <Text align="center" className={separatorTextStyle} variant="info_txt_1">
                Lub
            </Text>

            <LoginForm
                userSource={userSource}
                onSuccessfulSubmit={emailAuthSuccess}
                gtmSourceSection={gtmSourceSection}
                amplitudePlacement={amplitudePlacement}
            />
        </>
    );
};

const separatorTextStyle = css({
    pt: 1.5,
    textAlign: "center"
});
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {AmplitudeAuthPlacement} from "../../../tracking/types/AmplitudeAuthPlacement";
import {LoginForm} from "./LoginForm";
import {SocialAuth} from "./SocialAuth";

interface IProps {
    socialAuthSuccess: () => void;
    emailAuthSuccess: () => void;
    userSource: UserSource;
    gtmSourceSection?: string;
    amplitudePlacement?: AmplitudeAuthPlacement;
}

export const SemanticSearchLoginForm = (props: IProps) => {
    const {userSource, gtmSourceSection, socialAuthSuccess, emailAuthSuccess, amplitudePlacement} = props;

    return (
        <>
            <SocialAuth
                onAuthSuccess={socialAuthSuccess}
                userSource={userSource}
                gtmSourceSection={gtmSourceSection}
                amplitudePlacement={amplitudePlacement}
                authContext="login"
            />

            <Text align="center" className={separatorTextStyle} variant="info_txt_1">
                Lub
            </Text>

            <LoginForm
                userSource={userSource}
                onSuccessfulSubmit={emailAuthSuccess}
                gtmSourceSection={gtmSourceSection}
                amplitudePlacement={amplitudePlacement}
            />
        </>
    );
};

const separatorTextStyle = css({
    pt: 1.5,
    textAlign: "center"
});
